import React, { useRef, useState, useEffect } from "react";
import {
  MapContainer,
  TileLayer,
  Marker,
  Popup,
  Polygon,
  useMapEvents,
} from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import { Input, Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { formatDate } from "../../../helpers/formatDate";
import { createCustomIcon, profileCustomIcon, profileIcon } from "./helper";
import { toast } from "react-toastify";
import { fetchFormData, ticketsManagement } from "../../../helpers/backend_helper";
import { fetchTickets } from "../../../store/ticket/actions";
import { useDispatch } from "react-redux";

const MapEventHandler = ({ onZoomChange, onMapClick }) => {
  const map = useMapEvents({
    zoom: () => {
      onZoomChange(map.getZoom());
    },
    click: (e) => {
      onMapClick(e);
    },
  });
  return null;
};

const UpdateTicketMap = ({
  SelectedLocation,
  showGaurdLlocation: guardLocations,
  showCarLocations: vehicleLocations,
  showBeatLocations: beatLocations,
  initialLocation,
  formData,
}) => {
  const [searchQuery, setSearchQuery] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [zoom, setZoom] = useState(initialLocation?.lat ? 12 : 5);
  const [selectingLocation, setSelectingLocation] = useState(false);
  // Add state for confirmation modal
  const [confirmModal, setConfirmModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [initialFocusSet, setInitialFocusSet] = useState(false);

  const debounceTimeoutRef = useRef(null);
  const mapRef = useRef(null);
  const dispatch = useDispatch();

  useEffect(() => {
    // Only set the view to the incident location on initial render
    if (mapRef.current && initialLocation?.lat && initialLocation?.lng && !initialFocusSet) {
      mapRef.current.setView([initialLocation.lat, initialLocation.lng], zoom, {
        animate: true,
      });
      setInitialFocusSet(true); // Mark that we've set the initial focus
    }
  }, [initialLocation, zoom, initialFocusSet]);



// Define a function to validate location data
const validateLocationData = (location) => {
  return (
    location && 
    location.latitude && 
    location.longitude && 
    !isNaN(location.latitude) && 
    !isNaN(location.longitude)
  );
};

// Set up date constants
const today = new Date();
today.setHours(0, 0, 0, 0); // Normalize to start of the day

const yesterday = new Date(today);
yesterday.setDate(yesterday.getDate() - 1); // Set to yesterday

// Filter guard locations to only show those updated today or yesterday
const filteredGuardLocations = (guardLocations || [])
  .filter((guard) => {
    // First check if location data exists and has an updatedAt timestamp
    if (!guard?.currentLocation?.updatedAt) return false;
    
    // Make sure the location data is valid
    if (!validateLocationData(guard.currentLocation)) return false;
    
    // Parse the updatedAt date and normalize to start of day for comparison
    const updatedAtDate = new Date(guard.currentLocation.updatedAt);
    updatedAtDate.setHours(0, 0, 0, 0);
    
    // Return true if the location was updated today or yesterday
    return (
      updatedAtDate.getTime() === today.getTime() || 
      updatedAtDate.getTime() === yesterday.getTime()
    );
  });

  const handleMapClick = (e) => {
    if (selectingLocation) {
      const { lat, lng } = e.latlng;
      SelectedLocation({ lat, lng }); // Directly update the location
      setSelectingLocation(false); // Exit selection mode
    }
  };

  const handleUpdateLocation = () => {
    setSelectingLocation(!selectingLocation);
  };

  const customIcon = new L.Icon({
    iconUrl:
      "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png",
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    shadowSize: [41, 41],
  });
  

  const searchPlace = async (query) => {
    if (!query) return;

    const Payload = {
      act: "common",
      subact: "searchLLocation",
      info: {
        search: query,
      },
    };
    
    try {

      const response = await fetchFormData(Payload);

      if (response?.data?.Results && response?.data?.Results.length > 0) {
        setSearchResults(response?.data?.Results);
      } else {
        console.warn("No results found for the search query.");
        setSearchResults([]);
      }
    } catch (error) {
      console.error("Error searching place:", error);
    }
  };

  const handleInputChange = (e) => {
    const value = e.target.value;
    setSearchQuery(value);

    if (debounceTimeoutRef.current) {
      clearTimeout(debounceTimeoutRef.current);
    }

    debounceTimeoutRef.current = setTimeout(() => {
      searchPlace(`${value + ", chandrapur"}`);
    }, 500);
  };

  const handleSuggestionClick = (result) => {
    const { Geometry, Label } = result.Place || {};
    const latitude = Geometry?.Point[1];
    const longitude = Geometry?.Point[0];
    // Store as temp location instead of immediately updating
    setSearchResults([]); // Clear search results
    setSearchQuery(""); // Clear search input
  };

  // Function to show confirmation modal
  const showAssignConfirmation = (user) => {
    setSelectedUser(user);
    setConfirmModal(true);
  };

  // Function to close modal
  const closeModal = () => {
    setConfirmModal(false);
    setSelectedUser(null);
  };

  const handleEditTicket = async (ticketId) => {
    const payload = {
      act: "ticket",
      subact: "get",
      info: { ticketId },
    };
      const response = await ticketsManagement(payload);
      if (response?.message) {
      
      }
  }

  const assignUserToTicket = async () => {
    if (!selectedUser) return;
    const assignedUsers = Array.isArray(formData.assignedUsers) ? formData.assignedUsers : [];

    const userId = selectedUser.userId;
    const payload = {
      act: "ticket",
      subact: "assigned",
      info: {
        ticketId: formData.ticketId,
        assignedTo: [...assignedUsers, userId],
      },
    };
    
    try {
      const response = await ticketsManagement(payload);
      if (response?.message) {
        toast.success(response?.message, {
          position: "top-right",
          autoClose: 3000,
        });
        // handleEditTicket(formData.ticketId)
        // dispatch(fetchTickets({ status: "", search: "", limit: 50 }));
      }
      closeModal();
    } catch (error) {
      toast.error(error.response?.data?.message, {
        position: "top-right",
        autoClose: 3000,
      });
      closeModal();
    }
  };

  return (
    <div style={{ width: "100%" }} className="update-ticket">
      {/* Update Location Button */}
      <Button
        color="primary"
        onClick={handleUpdateLocation}
        style={{ marginBottom: "10px" }}
      >
        {selectingLocation ? "Cancel Selection" : "Update New Location"}
      </Button>
      <div
        style={{ marginBottom: "10px", width: "100%", position: "relative" }}
      >
        <Input
          type="text"
          value={searchQuery}
          onChange={handleInputChange}
          placeholder="Search for a place in India..."
          style={{ padding: "8px" }}
        />
        {searchResults.length > 0 && (
          <ul
            style={{
              position: "absolute",
              top: "40px",
              left: "0",
              right: "0",
              background: "white",
              border: "1px solid #ccc",
              listStyle: "none",
              margin: 0,
              padding: "10px",
              zIndex: 100000,
            }}
          >
            {searchResults.map((result, index) => (
              <li
                key={index}
                style={{
                  padding: "8px",
                  cursor: "pointer",
                  borderBottom: "1px solid #eee",
                }}
                onClick={() => handleSuggestionClick(result)}
              >
                {result.Place?.Label}
              </li>
            ))}
          </ul>
        )}
      </div>
      <MapContainer
        ref={mapRef}
        center={[
          initialLocation?.lat || 19.9615,
          initialLocation?.lng || 79.2961,
        ]}
        zoom={zoom}
        style={{ height: "70vh", width: "100%", borderRadius: "4px" }}
      >
        <MapEventHandler onZoomChange={setZoom} onMapClick={handleMapClick} />
         <TileLayer
                            url="http://{s}.google.com/vt/lyrs=s,h&x={x}&y={y}&z={z}"
                            subdomains={["mt0", "mt1", "mt2", "mt3"]}
                          />

        {/* Assigned Guard Markers */}
        {formData?.assignedUser?.map(
          (user) =>
            user?.info?.currentLocation && (
              <Marker
                key={
                  user.info.currentLocation.latitude +
                  user.info.currentLocation.longitude
                } // Unique key
                position={[
                  user.info.currentLocation.latitude,
                  user.info.currentLocation.longitude,
                ]}
                icon={profileCustomIcon(user?.profileUrl)}
                // icon={profileIcon(user?.profileUrl)}
              >
                <Popup closeButton={true}>
                  <strong>
                    {user.firstName} {user.lastName}
                  </strong>
                  <br />
                  <strong>{user.email}</strong>
                  <br />
                  {user.contactNumber && (
                    <>
                      <span>📞 {user.contactNumber}</span>
                      <br />
                    </>
                  )}
                  <strong>🌍</strong> {user.info.currentLocation.latitude},{" "}
                  {user.info.currentLocation.longitude}
                  <span>
                    <br />⏰ <strong>Last Update:</strong>{" "}
                    {formatDate(user.info.currentLocation.updatedAt)}
                  </span>
                </Popup>
              </Marker>
            )
        )}

        {/* Guard Markers */}
        {filteredGuardLocations?.map(
          (guard, index) =>
            guard?.currentLocation && (
              <Marker
                key={`guard-${index}`}
                position={[
                  guard.currentLocation.latitude,
                  guard.currentLocation.longitude,
                ]}
                icon={createCustomIcon(
                  guard?.profilePic,
                  guard?.currentLocation?.updatedAt,true
                )}
              >
                <Popup key={`guard-${index}`} closeButton={true}>
                  <div>
                    <strong>
                      {guard?.firstName} {guard?.lastName}
                    </strong>
                    <br />
                    {guard?.contactNumber && (
                      <>
                        <span>📞 {guard?.contactNumber}</span>
                        <br />
                      </>
                    )}
                    <span>
                      🌍 <strong>Location:</strong>{" "}
                      {guard?.currentLocation.latitude},{" "}
                      {guard?.currentLocation.longitude}
                    </span>
                    <br />
                    <span>
                      ⏰ <strong>Last Update:</strong>{" "}
                      {formatDate(guard?.currentLocation?.updatedAt)}
                    </span>
                    <div style={{ marginTop: "5px" }}>
                      <Button 
                        color="primary" 
                        size="sm" 
                        onClick={() => showAssignConfirmation(guard)}
                      >
                        Assign Ticket
                      </Button>
                    </div>
                  </div>
                </Popup>
              </Marker>
            )
        )}

        {/* Vehicle Markers */}
        {vehicleLocations?.map(
          (vehicle, index) =>
            vehicle?.currentLocation && (
              <Marker
                key={`vehicle-${index}`}
                position={[
                  vehicle.currentLocation.latitude,
                  vehicle.currentLocation.longitude,
                ]}
                icon={createCustomIcon(
                  vehicle?.profilePic,
                  vehicle?.currentLocation?.updatedAt,false
                )}
              >
                <Popup closeButton={true}>
                  <div>
                    <strong>
                      Vehicle: {vehicle.carId || "Unknown"}
                    </strong>
                    <br />
                    {vehicle.driverName && (
                      <>
                        <strong>Driver:</strong> {vehicle.driverName}
                        <br />
                      </>
                    )}
                    {vehicle.contactNumber && (
                      <>
                        <span>📞 {vehicle.contactNumber}</span>
                        <br />
                      </>
                    )}
                    <span>
                      ⏰ Last Update:{" "}
                      {formatDate(vehicle.currentLocation.updatedAt)}
                    </span>
                    <div style={{ marginTop: "5px" }}>
                      <Button 
                        color="primary" 
                        size="sm" 
                        onClick={() => showAssignConfirmation(vehicle)}
                      >
                        Assign Ticket
                      </Button>
                    </div>
                  </div>
                </Popup>
              </Marker>
            )
        )}

        {/* Beat Markers */}
        {beatLocations &&
          beatLocations.map((beat, index) => {
            // Ensure coordinates exist and are in the correct format
            const validCoordinates = beat?.coordinates
              ?.map((coord) =>
                Array.isArray(coord) ? [coord[1], coord[0]] : null
              )
              .filter((coord) => coord !== null);

            return validCoordinates && validCoordinates.length > 0 ? (
              <Polygon
                key={beat.beatId || index}
                positions={validCoordinates}
                pathOptions={{
                  color: "#2196f3",
                  fillColor: "#2196f3",
                  fillOpacity: 0.2,
                  weight: 2,
                }}
              >
                <Popup closeButton={true}>
  <div>
    {beat?.name && (
      <>
        <strong>Beat Name:</strong> {beat.name}
        <br />
        <strong>Range Name:</strong> {beat.rangeName}
        <br />
        {beat.assignedGuards.length > 0 && (
          <>
            <strong>Assigned Guards:</strong>
            <div>
              {beat.assignedGuards.map((guard) => (
                <div key={guard.userId} className="d-flex align-items-center justify-content-between mt-2">
                  <span>
                    {guard.firstName} {guard.lastName}  
                  </span> 
                  <Button 
                    color="primary" 
                    size="sm" 
                    onClick={() => showAssignConfirmation(guard)}
                  >
                      {" "}Assign Ticket
                  </Button>
                </div>
              ))}
            </div>
          </>
        )}
      </>
    )}
  </div>
</Popup>

              </Polygon>
            ) : null;
          })}

        {/* Initial Location Marker */}
        {initialLocation?.lat && initialLocation?.lng && (
          <Marker
            key="initial-location"
            position={[initialLocation?.lat, initialLocation?.lng]}
            icon={customIcon}
          >
            <Popup closeButton={true}>
              <strong>Location:</strong> {initialLocation?.lat},
              {initialLocation?.lng}
            </Popup>
          </Marker>
        )}
      </MapContainer>

      {/* Confirmation Modal */}
      <Modal isOpen={confirmModal} toggle={closeModal}>
        <ModalHeader toggle={closeModal}>Confirm Assignment</ModalHeader>
        <ModalBody>
          Are you sure you want to assign this ticket to <strong>{selectedUser?.firstName} {selectedUser?.lastName} {selectedUser?.carId}</strong>?
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={assignUserToTicket}>
            Yes
          </Button>
          <Button color="secondary" onClick={closeModal}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default UpdateTicketMap;